import { applyMiddleware, compose, createStore } from 'redux';
import { routerMiddleware } from 'react-router-redux';
import createHistory from 'history/createHashHistory';
import createSagaMiddleware from 'redux-saga';
import { composeWithDevTools } from 'redux-devtools-extension';
import reducers from '../reducers/index';
import rootSaga from '../sagas/index';
import devOverlayInterceptorImpl from '../__dev__/devOverlayInterceptorMiddleware';

const history = createHistory();
const routeMiddleware = routerMiddleware(history);
const sagaMiddleware = createSagaMiddleware();

const devOverlayInterceptor =
  process.env.NODE_ENV !== 'production' ? devOverlayInterceptorImpl : null;

const middlewares = [
  sagaMiddleware,
  routeMiddleware,
  ...(devOverlayInterceptor ? [devOverlayInterceptor] : []),
];

const getComposeParams = () => {
  if (process.env.NODE_ENV !== 'production') {
    return [composeWithDevTools(applyMiddleware(...middlewares))];
  }

  return [applyMiddleware(...middlewares)];
};

export default function configureStore(initialState) {
  const store = createStore(reducers, initialState, compose(...getComposeParams()));

  sagaMiddleware.run(rootSaga);

  return store;
}
export { history };
